<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <app-notificacoes-perfis *ngIf="mensagens" [notificacaoMensagens]="mensagens" [notificacaoStatus]="statusSucesso"
        (fecharNotificacoes)="mensagens = []">
      </app-notificacoes-perfis>
    </div>
    <div class="col-4">
      <h2>Lista de Perfis</h2>
    </div>
    <div class="col-6 offset-2 text-end">
      <button class="btn btn-secondary" [disabled]="usuariosDaEntidade.length == 0 || lstperfis.length == 0"
        (click)="gerenciarUsuariosDoPerfil()"><i class="fa fa-users" aria-hidden="true"></i> Gerenciar Usuários</button>
      <button class="btn btn-terceary" routerLink='criar-perfil'> <i class="fa fa-plus" aria-hidden="true"></i> Criar
        Perfil</button>
    </div>


    <div class="col">
      <table class="table table-striped table-hover" id="tabela-perfis">
        <thead>
          <tr>
            <th>Nome do Perfil</th>
            <th>Perfil esta ativo?</th>
            <th>Quantidades de Usuários no Perfil</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of lstperfis | paginate: { id: 'some_id', itemsPerPage: 50, currentPage: paginaAtual };">
            <td>{{p.dscperfil}}</td>
            <td>{{p.indativo? 'Sim': 'Não'}}</td>
            <td>{{ p.usuarios?.length || 0 }}</td>
            <td class="text-end">
              <button class="btn btn-secondary" (click)="mostrarEditarPerfil(p, true)">
                <i class="fa fa-eye" aria-hidden="true"></i> Detalhar Perfil</button>
              <button class="btn btn-terceary" (click)="mostrarEditarPerfil(p, false)">
                <i class="fa fa-edit" aria-hidden="true"></i> Editar Perfil</button>
            </td>
          </tr>
          <tr *ngIf="!lstperfis">
            <td colspan="3">Nenhum perfil encontrado</td>
          </tr>
        </tbody>
        <tfoot *ngIf="lstperfis">
          <tr>
            <th colspan="3">
              <pagination-controls  id="some_id" nextLabel="" previousLabel="" (pageChange)="paginaAtual = $event"></pagination-controls>
            </th>
            <th class="text-end">
              <button (click)="exportTableToExcel('tabela-perfis', 'Lista-Perfis')" class="btn btn-info"><i
                  class="fa fa-file-excel-o"></i> Exportar para
                excel</button>
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<div class="modal fade" id="add-usuario-ao-perfil" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="add-usuario-ao-perfilLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="add-usuario-ao-perfilLabel">Add Usuários ao Perfil</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body ">
        <table class="table table-striped table-hover" id="tabela-usuarios">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Login</th>
              <th>Perfil</th>
              <th>Perfil App Gestão de Abastecimento</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of usuariosDaEntidade | paginate: { id: 'pUser', itemsPerPage: 10, currentPage: paginaAtual };">
              <td class="cssNomeEmail">{{u.dscNome.toUpperCase()}} <span>{{u.dscEmail}}</span></td>
              <td>{{u.dscLogin.toUpperCase()}}</td>
              <td>
                <select class="form-select" aria-label="Default select example">
                  <option *ngFor="let p of lstperfis" [selected]="p.codperfil == u.codPerfil" value={{p.codperfil}}>
                    {{p.dscperfil.toUpperCase()}}
                  </option>
                </select>
              </td>
              <td>{{u.dscPerfilApp.toUpperCase()}}</td>
              <td>{{u.dscStatus.toUpperCase()}}</td>
              <td class="text-end">
                <button class="btn btn-terceary">
                  <i class="fa fa-check" aria-hidden="true"></i> Salvar</button>
                <button class="btn btn-secondary">
                  <i class="fa fa-delete" aria-hidden="true"></i> Desativar</button>
              </td>
            </tr>
            <tr *ngIf="!usuariosDaEntidade">
              <td colspan="6">Nenhum usuário encontrado</td>
            </tr>
          </tbody>
          <tfoot *ngIf="usuariosDaEntidade">
            <tr>
              <th colspan="4">
                <pagination-controls id="pUser" nextLabel="" previousLabel=""
                  (pageChange)="paginaAtual = $event"></pagination-controls>

              </th>
              <th colspan="2" class="text-end">
                <button (click)="exportUsuariosToExcel('tabela-usuarios', 'Lista-usuarios')" class="btn btn-info"><i
                    class="fa fa-file-excel-o"></i> Exportar para
                  excel</button>
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>